"use client";

import React from "react";
import { Hexagon, Triangle, Circle, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Single-Family Homes",
  description: "Precision structural engineering to stabilize residential foundations, addressing settlement and soil movement issues.",
  icon: Hexagon,
  link: "/ExpertisePage"
}, {
  title: "Duplexes & 4-Plexes",
  description: "Specialized multi-unit foundation correction ensuring long-term structural integrity for high-density residential assets.",
  icon: Triangle,
  link: "/ExpertisePage"
}, {
  title: "Commercial Buildings",
  description: "Comprehensive engineering evaluations and structural retrofitting for large-scale commercial and industrial facilities.",
  icon: Circle,
  link: "/ExpertisePage"
}];
export default function CreativeVectors() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223729" id="foundation-correction-specialists" className="bg-secondary text-foreground py-24 md:py-32 px-6 md:px-12 overflow-hidden" ref={ref}>
      <div className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="text-sm font-mono tracking-widest uppercase text-muted-foreground mb-6">
              Engineering Expertise
            </h2>
            <p className="text-3xl md:text-5xl font-default font-bold leading-tight tracking-tight">
              Structural solutions for complex foundation challenges across California and Utah.
            </p>
          </div>
          <Button asChild variant="outline" className="rounded-none border-border hover:bg-primary hover:text-primary-foreground transition-colors w-fit">
            <Link to="/ExpertisePage">
              View All Services <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group rounded-none border border-border bg-card hover:shadow-lg hover:border-l-4 hover:border-l-ring transition-all duration-300 ease-out hover:-translate-y-2 flex flex-col">
                <CardHeader className="pt-12 pb-8 px-8 md:px-10">
                  <Icon className="size-12 stroke-[1.5px] mb-12 text-primary group-hover:text-ring transition-colors duration-300" />
                  <CardTitle className="font-default text-3xl font-bold tracking-tight text-foreground transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 md:px-10 pb-8 flex-grow">
                  <CardDescription className="text-lg text-muted-foreground font-default leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="px-8 md:px-10 pb-12 pt-0">
                  <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-ring font-mono uppercase tracking-widest text-sm">
                    <Link to={service.link}>
                      Technical Specs <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-2" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>

      </div>
    </section>;
}